// extracted by mini-css-extract-plugin
export var active = "_94-7";
export var container = "_94-0";
export var evenWidth = "_94-4";
export var large = "_94-5";
export var outlet = "_94-8";
export var slide = "_94-2";
export var small = "_94-6";
export var tab = "_94-3";
export var tabs = "_94-1";